import { useCallback } from "react";

declare global {
  interface Window {
    gtag?: (
      command: "event",
      eventName: string,
      parameters?: Record<string, any>
    ) => void;
  }
}

export const useTrackAccountCreation = () => {
  const trackCreateAccount = useCallback(() => {
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "create_account", {
        method: "email",
      });
    }
  }, []);

  return { trackCreateAccount };
};
